// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.row_started{background-color:#e8f5e9!important}.row_pause_started{background-color:#fffde7!important}.row_empty{background-color:#fff!important}", ""]);
// Exports
module.exports = exports;
